// Mock data for galleries
export const galleryData = {
  color: {
    title: "צביעה מקצועית",
    subtitle: "צביעת רהיטים בטכניקות מתקדמות",
    description: "גלו את מגוון הטכניקות המתקדמות שלנו לצביעת רהיטים.",
    images: [
      {
        url: "/images/color/0a6a487b-2d29-4ad5-a495-39f5790ef374_20260118_005937.webp",
        title: "0a6a487b 2d29 4ad5 a495 39f5790ef374",
        description: "עבודת צביעה מקצועית מהגלריה שלנו"
      },
      {
        url: "/images/color/IMG_5011_20260119_092825.webp",
        title: "IMG 5011",
        description: "עבודת צביעה מקצועית מהגלריה שלנו"
      },
      {
        url: "/images/color/c7ef153d-f499-4f5d-9916-cf3098ab8ae1_20260118_005939.webp",
        title: "c7ef153d f499 4f5d 9916 cf3098ab8ae1",
        description: "עבודת צביעה מקצועית מהגלריה שלנו"
      },
      {
        url: "/images/color/ded0131a-2932-4645-bf68-597ad390a079_20260118_005938.webp",
        title: "ded0131a 2932 4645 bf68 597ad390a079",
        description: "עבודת צביעה מקצועית מהגלריה שלנו"
      },
      {
        url: "/images/color/דלת כניסה RAL 7044_20260121_092730.webp",
        title: "דלת כניסה RAL 7044",
        description: "עבודת צביעה מקצועית מהגלריה שלנו"
      }
    ]
  },
  wood: {
    title: "עבודות עץ מקצועיות",
    subtitle: "שחזור והחייאת רהיטי עץ עתיקים",
    description: "מתמחים בעבודות עץ מורכבות ושחזור רהיטים עתיקים.",
    images: [
      {
        url: "/images/wood/15244C0E-39CB-4C34-872E-633F6728A604_20260118_005950.webp",
        title: "15244C0E 39CB 4C34 872E 633F6728A604",
        description: "עבודת עץ איכותית מהגלריה שלנו"
      },
      {
        url: "/images/wood/D320A096-C8D0-4438-8841-B0A43369780D_20260118_005948.webp",
        title: "D320A096 C8D0 4438 8841 B0A43369780D",
        description: "עבודת עץ איכותית מהגלריה שלנו"
      },
      {
        url: "/images/wood/IMG_0245_20260118_005942.webp",
        title: "IMG 0245",
        description: "עבודת עץ איכותית מהגלריה שלנו"
      },
      {
        url: "/images/wood/IMG_0246_20260118_005943.webp",
        title: "IMG 0246",
        description: "עבודת עץ איכותית מהגלריה שלנו"
      },
      {
        url: "/images/wood/IMG_0247_20260118_005946.webp",
        title: "IMG 0247",
        description: "עבודת עץ איכותית מהגלריה שלנו"
      },
      {
        url: "/images/wood/IMG_5010_20260119_092826.webp",
        title: "IMG 5010",
        description: "עבודת עץ איכותית מהגלריה שלנו"
      },
      {
        url: "/images/wood/בייץ למדרגות לפי התאמת לקוח _20260121_092732.webp",
        title: "בייץ למדרגות לפי התאמת לקוח ",
        description: "עבודת עץ איכותית מהגלריה שלנו"
      },
      {
        url: "/images/wood/פטינה _20260121_092733.webp",
        title: "פטינה ",
        description: "עבודת עץ איכותית מהגלריה שלנו"
      }
    ]
  },
  renovations: {
    title: "חידוש רהיטים יצירתי",
    subtitle: "שילוב טכניקות עץ וצבע ליצירת פריטים ייחודיים",
    description: "מתמחים בחידוש יצירתי של רהיטים ישנים.",
    images: [
      {
        url: "/images/renovations/7f4c6f9e-c143-4ed8-953e-fa2289f620ef_20260118_005952.webp",
        title: "7f4c6f9e c143 4ed8 953e fa2289f620ef",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/D320A096-C8D0-4438-8841-B0A43369780D_20250717_103219.webp",
        title: "D320A096 C8D0 4438 8841 B0A43369780D",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/IMG_0083_20260118_005958.webp",
        title: "IMG 0083",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/IMG_0119_20260118_005955.webp",
        title: "IMG 0119",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/IMG_0135_20260118_010004.webp",
        title: "IMG 0135",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/IMG_9684_20260118_010002.webp",
        title: "IMG 9684",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/IMG_9715_20260118_010000.webp",
        title: "IMG 9715",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/IMG_9727_20260118_010011.webp",
        title: "IMG 9727",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/IMG_9826_20260118_010009.webp",
        title: "IMG 9826",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/IMG_9866_20260118_010006.webp",
        title: "IMG 9866",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/IMG_9867_20260118_010012.webp",
        title: "IMG 9867",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      },
      {
        url: "/images/renovations/f74eea0d-7713-430f-8378-fc8afac0169e_20260118_005953.webp",
        title: "f74eea0d 7713 430f 8378 fc8afac0169e",
        description: "פרויקט חידוש מקצועי מהגלריה שלנו"
      }
    ]
  }
};

// Before and After projects
export const beforeAfterProjects = [
  {
    project: "project1",
    title: "project1",
    before: "/images/before-after/project1/before.webp",
    after: "/images/before-after/project1/after.webp"
  },
  {
    project: "פרויקט1",
    title: "פרויקט1",
    before: "/images/before-after/פרויקט1/before.webp",
    after: "/images/before-after/פרויקט1/after.webp"
  }
];

// Mock data for testimonials
export const testimonials = [
  {
    id: 1,
    name: "רחל כהן",
    text: "השירות היה מעולה! הרהיטים שלנו נראים כמו חדשים לגמרי. המקצועיות והתשומת לב לפרטים הקטנים הפתיעו אותי.",
    rating: 5
  },
  {
    id: 2,
    name: "דוד לוי",
    text: "המחיר הוגן והתוצאה מעבר לכל הציפיות. הצוות מקצועי ואדיב, בהחלט נחזור שוב.",
    rating: 5
  },
  {
    id: 3,
    name: "שרה אברהם",
    text: "שדרגו לנו את כל הרהיטים בסלון. העבודה הייתה מדויקת ומהירה. ממליצה בחום!",
    rating: 5
  }
];

// Mock data for projects
export const projects = [
  {
    id: 1,
    title: "שדרוג סלון מלא",
    description: "צביעה מחדש של כל רהיטי הסלון בגוונים חמים",
    category: "color",
    image: "https://images.unsplash.com/photo-1642030046046-4147729c9b40",
    beforeAfter: {
      before: "https://images.unsplash.com/photo-1532588213355-52317771cce6",
      after: "https://images.unsplash.com/photo-1642030046046-4147729c9b40"
    }
  },
  {
    id: 2,
    title: "שחזור כיסא עתיק",
    description: "שחזור מלא של כיסא עתיק מהתקופה העותמאנית",
    category: "wood",
    image: "https://images.unsplash.com/photo-1712171984530-e25a4aaa46dd",
    beforeAfter: {
      before: "https://images.pexels.com/photos/276651/pexels-photo-276651.jpeg",
      after: "https://images.unsplash.com/photo-1712171984530-e25a4aaa46dd"
    }
  },
  {
    id: 3,
    title: "חידוש שולחן עם טכניקה מיוחדת",
    description: "שילוב של צביעה ועבודת עץ ליצירת עיצוב ייחודי",
    category: "innovations",
    image: "https://images.unsplash.com/photo-1618588291966-fd658dab68a8",
    beforeAfter: {
      before: "https://images.unsplash.com/photo-1597072689227-8882273e8f6a",
      after: "https://images.unsplash.com/photo-1618588291966-fd658dab68a8"
    }
  }
];